import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import './RealOutcomes.css';

const RealOutcomes = () => {
  const cards = [
    {
      num: '01',
      title: 'Revenue Exchange',
      desc: 'Get in front of enterprise buyers, channel partners and corporate innovation teams.',
      href: '/revenue',
      icon: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <line x1="7" y1="17" x2="17" y2="7"></line>
          <polyline points="7 7 17 7 17 17"></polyline>
        </svg>
      )
    },
    {
      num: '02',
      title: 'Capital Office',
      desc: 'Meet relevant investors through curated mandates, private rooms and round preparation.',
      href: '/capitaloffice',
      // Concentric circles SVG
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <circle cx="12" cy="12" r="4"></circle>
        </svg>
      )
    },
    {
      num: '03',
      title: 'Founder Circles',
      desc: 'Solve high-stakes problems with stage-matched founders in confidential peer groups.',
      href: '/founderscircle',
      // Single circle SVG
      icon: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="9"></circle>
        </svg>
      )
    },
    {
      num: '04',
      title: 'Global Expansion',
      desc: 'Access customers, partners and advisors across focused international market corridors.',
      href: '/globalexpansion',
      // Lightning / Zap SVG
      icon: (
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
        </svg>
      )
    }
  ];

  return (
    <div className="ro-wrapper">
      <div className="ro-container">
        {/* Header Section */}
        <div className="ro-header-section">
          <Grid container spacing={2} alignItems="flex-end">
            <Grid item xs={12} md={7}>
              <Typography className="ro-subheading">HOW MARKOKNOW HELPS</Typography>
              <Typography className="ro-heading-main">
                Built to create <br />
                <span className="ro-heading-italic">real outcomes.</span>
              </Typography>
            </Grid>
            <Grid item xs={12} md={5} className="ro-desc-wrapper">
              <Typography className="ro-description">
                Every program is designed around a measurable founder need—not another calendar of generic networking events.
              </Typography>
            </Grid>
          </Grid>
        </div>

        {/* Cards Section */}
        <div className="ro-cards-section">
          <Grid container>
            {cards.map((card, index) => (
              <Grid item xs={12} sm={6} md={3} key={index} className="ro-card-col">
                <div className="ro-card">
                  <div className="ro-card-top">
                    <div className="ro-icon-circle">
                      {card.icon}
                    </div>
                    <Typography className="ro-card-num">{card.num}</Typography>
                  </div>

                  <Typography className="ro-card-title">{card.title}</Typography>
                  <Typography className="ro-card-desc">{card.desc}</Typography>

                  <div className="ro-card-bottom">
                    <hr className="ro-divider" />
                    <a href={card.href || "#"} className="ro-explore-link">
                      <span>EXPLORE</span>
                      <span className="ro-explore-arrow">↗</span>
                    </a>
                  </div>
                </div>
              </Grid>
            ))}
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default RealOutcomes;